import { Divider, Input } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { PageHeader } from '../theme/theme';

const SavingsItemStyle = styled(Link)`
	padding: 20px;
	border-bottom: 1px solid #ddd;
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	transition: background-color 400ms ease;

	& .desc {
		width: 75%;
		font-size: 15px;
		color: #969696;
		margin-top: 10px;
	}

	& .icon {
		width: 50px;
		display: flex;
		flex-direction: column;
		height: 100%;
		justify-content: flex-start;
		margin-right: 10px;
	}

	&:hover {
		background-color: #fafafa;
	}
`;

const OverViewPage = () => {
	const items = [
		{
			title: 'Account Snapshot',
			desc: 'View your account balance and recent transactions.',
			link: '/overview/account-snapshot',
			icon: 'savings',
		},
		{
			title: 'Wallet Snapshot',
			desc: 'Manage your digital assets and transaction history.',
			link: '/overview/wallet-snapshot',
			icon: 'wallet',
		},
		{
			title: 'Salary Sender',
			desc: 'Send multiple transactions to different addresses efficiently.',
			link: '/overview/bulk-sender',
			icon: 'send_to_mobile',
		},
		{
			title: 'Payroll',
			desc: 'Track your income, expenses, and financial records.',
			link: '/overview/money-book',
			icon: 'book',
		},
		{
			title: 'Commercial Banks',
			desc: 'Track your income, expenses, and financial records.',
			link: '/overview/commercial-banks',
			icon: 'bank',
		},
	];

	return (
		<section>
			<PageHeader>Overview</PageHeader>

			<Input.Search placeholder="Search Settings" />

			<Divider />

			<p>Frequently visited</p>

			<Divider />

			{items
				.sort((prev, next) => prev.title.localeCompare(next.title))
				.map((item) => (
					<SavingsItemStyle key={item.title} to={item.link}>
						<div style={{ display: 'flex' }}>
							<div className="icon">
								<span className="material-icons">{item.icon}</span>
							</div>
							<div>
								<p>
									<strong>{item.title}</strong>
								</p>
								<p className="desc">{item.desc}</p>
							</div>
						</div>
						<div className="arrow">
							<span className="material-icons">keyboard_arrow_right</span>
						</div>
					</SavingsItemStyle>
				))}
		</section>
	);
};

export default OverViewPage;
